module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 76.6c9dc764.png";